import { render, staticRenderFns } from "./expandable-panel.vue?vue&type=template&id=2dd0ac48&"
import script from "./expandable-panel.vue?vue&type=script&lang=js&"
export * from "./expandable-panel.vue?vue&type=script&lang=js&"
import style0 from "./expandable-panel.vue?vue&type=style&index=0&id=2dd0ac48&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports